import React, { Component } from 'react';
import { find, omit, isEmpty, isNil } from 'lodash';

export default class ValidatedField extends Component {
  state = { valid: null, message: null };

  componentDidMount = () => {
    this.onValidate(this.props, { falseValue: null });
  };

  componentWillReceiveProps = newProps => {
    if (newProps.value !== this.props.value) {
      this.onValidate(newProps);
    }
  };

  onValidate = (newProps, { falseValue } = { falseValue: false }) => {
    const broken = find(this.props.validators, ({ isValid, message }) => !isValid(newProps.value));
    const valid = broken === undefined ? true : falseValue;
    const message = valid ? null : broken.message;

    if (this.state.valid !== valid || message !== this.state.message) {
      this.setState({ valid, message }, this.onValidationChanged);
    }
  };

  onValidationChanged = () => {
    this.props.onValidate(this.props.name, this.state.valid, this.state.message);
  };

  render() {
    const Tag = this.props.tag;
    const rest = omit(this.props, 'tag', 'onValidate', 'validators');

    return <Tag {...rest} onBlur={() => this.onValidate(this.props)} />;
  }
}

export const PRESENCE = { isValid: val => !!val, message: 'This field is required' };
export const BOOLEAN_PRESENCE = { isValid: val => !isNil(val), message: 'This field is required' };
export const POSITIVE = {
  isValid: val => PRESENCE.isValid(val) && parseInt(val) > 0,
  message: 'Please enter a positive number',
};
export const lessThanOrEqualTo = lte => ({
  isValid: val => val <= lte,
  message: `Please enter a value less than or equal to ${lte}`,
});

ValidatedField.defaultProps = {
  validators: [PRESENCE],
};

export function validationHandler(name, isValid, message) {
  this.setState(state => {
    let update = {
      validated: Object.assign({}, state.validated, { [name]: isValid }),
    };

    if (isValid === true) {
      update.errors = omit(state.errors, name);
    } else if (isValid === false) {
      update.errors = Object.assign({}, state.errors, { [name]: message });
    }

    return Object.assign({}, state, update);
  });
}
